import { Snackbar } from '@material-ui/core';
import React from 'react';
import { Alert } from '@material-ui/lab';

const AlertCoupon = ({
  valid, setIsValid, error, setErrorAlert,
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsValid(null);
    setErrorAlert(null);
  };

  return (
    <div>
      <Snackbar open={valid === false} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} variant="filled" severity="warning">
          Cupom inválido!
        </Alert>
      </Snackbar>
      <Snackbar open={valid} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} variant="filled" severity="success">
          Cupom inserido com sucesso!
        </Alert>
      </Snackbar>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} variant="filled" severity="error">
          Ocorreu um erro ao inserir o cupom! Tente novamente ou atualize a página.
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AlertCoupon;
